// extracted by mini-css-extract-plugin
module.exports = {"file":"file--30QjumTnI"};